/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { RootState } from './store.typings';

export const selectUiType = (state: RootState) => state.userReducer.authData?.uiType; //TODO remove
export const selectUserRoles = (state: RootState) => state.userReducer.authData?.roles; //TODO remove
export const selectRouterState = (state: RootState) => state.routerState;
export const selectCurrentRouteName = (state: RootState) => state.routerState.route.name;
export const selectCurrentRouteParams = (state: RootState) => state.routerState.route.params;
export const selectAlertsState = (state: RootState) => state.alertsReducer;
export const selectLocaleId = (state: RootState) => state.userReducer.localeId;
export const selectShortLists = (state: RootState) => state.shortListsReducer;
